// Consume once, only after getDeviceUuid has reconciled the native installation.
// Failures go through the normal API client (including account-deletion handling).
export async function registerWithEarlyResult(uuid, register) {
    window.__stopEarlyDeviceRegistration?.();
    delete window.__stopEarlyDeviceRegistration;
    const entry = window.__earlyDeviceRegistration;
    delete window.__earlyDeviceRegistration;
    if (entry && entry.uuid === uuid && entry.installation === window.NATIVE_INSTALLATION_ID
        && Date.now() - entry.startedAt < 30000) {
        const result = await entry.promise;
        // Do not automatically wait a second 15 seconds after a hung connection.
        // App's existing error screen owns the user's retry.
        if (entry.timedOut) throw new Error('Device registration timed out');
        if (result && localStorage.getItem('pill_reminder_uuid') === uuid
            && window.NATIVE_INSTALLATION_ID === entry.installation) return result;
    }
    return register(uuid);
}
